import { Control, ControlCodes, getControlName } from "@theprelude/core";
import { HelpIcon } from "@theprelude/ds";
import { z } from "zod";
import { IntegrationForm } from "../integration-form";

const controlCode = ControlCodes.VECTR;
const controlName = getControlName(controlCode);

export const VectrIntegrationForm = ({ instance }: { instance?: Control }) => (
  <IntegrationForm
    control={controlCode}
    instanceId={instance?.instance_id}
    instanceName={instance?.name ?? undefined}
    description={`${controlName} allows you to run and record the results of purple teams in your environment.`}
    fields={{
      environmentName: {
        label: "Environment Name",
        defaultValue: instance?.username?.split("/")?.[0],
        required: true,
        validator: z.string().min(1),
      },
      organizationName: {
        label: "Organization Name",
        defaultValue: instance?.username?.split("/")?.[1],
        required: true,
        validator: z.string().min(1),
      },
      api: {
        label: "API Key",
        type: "password",
        required: true,
        validator: z.string().min(1),
      },
      secret: {
        label: "API Secret",
        type: "password",
        required: true,
        validator: z.string().min(1),
      },
      baseUrl: {
        label: "Base URL",
        type: "url",
        defaultValue: instance?.api,
        required: true,
        validator: z.string().url(),
      },
    }}
    transformParams={({
      api,
      baseUrl,
      environmentName,
      organizationName,
      secret,
    }) => ({
      user: `${environmentName}/${organizationName}`,
      api: baseUrl,
      secret: `${api}/${secret}`,
    })}
    help={
      <a
        href="https://support.preludesecurity.com/docs/vectr"
        target="_blank"
        className="mb-2 flex cursor-pointer flex-row items-center justify-start gap-2 text-sm text-primary-foreground underline underline-offset-2 font-normal"
        rel="noreferrer"
      >
        <HelpIcon className="size-4 text-secondary-foreground" />{" "}
        <span>Where do I find my {controlName} credentials?</span>
      </a>
    }
  />
);
